var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "w100" },
    [
      _c("app-browse", {
        ref: "browse",
        attrs: {
          "data-source": _vm.dataSource,
          "selected-items": _vm.selectedItems,
          "url-query-params": "",
          "button-bar-items": _vm.buttonBarItems,
        },
        on: {
          state: function ($event) {
            _vm.browseState = $event
          },
        },
      }),
      _vm.createModalOpen
        ? _c(
            "w-modal",
            { attrs: { value: "" } },
            [
              _c("app-create", {
                on: {
                  close: function ($event) {
                    return _vm.closeCreateModal()
                  },
                  saved: function ($event) {
                    return _vm.updateView()
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.toEditAccount
        ? _c(
            "w-modal",
            { attrs: { value: "" } },
            [
              _c("app-edit", {
                attrs: { value: _vm.toEditAccount },
                on: {
                  close: function ($event) {
                    _vm.toEditAccount = null
                  },
                  saved: function ($event) {
                    return _vm.updateView()
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.uploadModalOpen
        ? _c(
            "w-modal",
            { attrs: { value: "" } },
            [
              _c("app-upload-csv-modal", {
                on: {
                  fetch: function ($event) {
                    return _vm.refresh()
                  },
                  close: function ($event) {
                    _vm.uploadModalOpen = false
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }